import ls from '@/helpers/localStorage';
import ss from '@/helpers/sessionStorage';

// maps url parameters to endpoint parameter names
const VARIABLES = {
  PIReferral: 'piReferral',
  utm_campaign: 'marketingProgram',
  utm_source: 'marketingSource',
  utm_code: 'depositPromoCode',
  instant_credit: '',
  mmpInstallId: 'mmpInstallId',
  mediaBypass: 'insightsBypass',
};

function getStorage(name) {
  const localStorageVariables = ['utm_code', 'mediaBypass'];
  if (localStorageVariables.includes(name)) {
    return ls;
  }
  return ss;
}

function check(route) {
  Object.keys(VARIABLES).forEach((key) => {
    const value = route.query[key];
    if (value) {
      const storage = getStorage(key);
      storage.set(key, value);
    }
  });
}

function get(name) {
  const storage = getStorage(name);
  const value = storage.get(name, null);
  if (value !== null) {
    return {
      name: VARIABLES[name],
      value,
    };
  }
  return null;
}

function payload(oldPayload, ...names) {
  const data = {};
  names.forEach((name) => {
    const storage = getStorage(name);
    const value = storage.get(name, null);
    if (value !== null) {
      data[VARIABLES[name]] = value;
    }
  });
  return {
    ...oldPayload,
    ...data,
  };
}

function clear() {
  ss.del('PIReferral');
  ss.del('utm_campaign');
  ss.del('utm_source');
  ss.del('utm_code');
  ss.del('mmpInstallId');
  ls.del('utm_code');
}

export default {
  check,
  get,
  payload,
  clear,
};
